var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-character",class:'state-animate-' + _vm.animationState},[_c('img',{attrs:{"alt":"Character","height":"300","src":_vm.imageUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }